import { bindTypesToActions } from '@src/utils/redux_utils';

const types = {
  AddStories: 'STORIES_ADD_STORIES',
  SetIdentifier: 'STORIES_SET_IDENTIFIER',
  ClearStories: 'STORIES_CLEAR_STORIES',
  UpdateStories: 'STORIES_UPDATE_STORIES',

  //saga actions:
  GetStories: 'STORIES_GET_STORIES'
};

const StoriesActions = bindTypesToActions( types );

const initialState = {
  storyList: [],
  uniqueId: null, /** profileid/level/seriesid/language */
  page:1
};

const StoriesReducer = (state = initialState, { type, payload }) => {
  
  switch (type) {
  
    case types.AddStories:
      const { stories: newStories } = payload ;

      if( !Array.isArray( newStories ) || !newStories.length ) return  state;
      return {
        ...state,
        page: state.page + 1,
        storyList: state.storyList.concat( newStories )
      }

    case types.SetIdentifier:
        const { uniqueId } = payload ; 
         //if course changed:

        if( state.uniqueId !== uniqueId ) return {
                uniqueId,
                storyList:[],
                page: 1
            } 
        else return state ;
    
    case types.UpdateStories:
      const { contents } = payload ;

      return {
        ...state,
        storyList: state.storyList.map( story =>{
          const matchContent = contents.find( content => content.contentid === story.contentid );
          if( matchContent ){
            story.watchedduration = matchContent?.watchedduration ?? 0 ;
            story.iscompletedonce = matchContent?.iscompletedonce ?? false ;
            story.status = matchContent?.status ?? '' ;
            story.assessment = matchContent?.assessment ?? null ; 
          }
          return story ;
        })
      }

    case types.ClearStories:
      return initialState ;

    default:
      return state;
  }
};

export { types as StoriesTypes, StoriesReducer, StoriesActions };
